import Header from '@/components/Header'
import Footer from '@/components/Footer'
import { useTrackPageView } from '@/hooks/useTrackPageView'

export default function Layout({ children }: { children: React.ReactNode }) {
  useTrackPageView()
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  )
}
